interface ScrollTarget {
  pageNumber?: string;
  blockIndex?: number;
}

interface ScrollToPositionOptions {
  maxTries?: number;
  delayMs?: number;
}

function getScrollTarget({ pageNumber, blockIndex }: ScrollTarget) {
  if (pageNumber) {
    return document.querySelector(`[data-pagenumber="${pageNumber}"]`);
  }
  return document.getElementById(`b${blockIndex}`);
}

async function waitAndScroll(
  getScrollTargetFn: () => Element | null,
  { maxTries = 20, delayMs = 50 }: ScrollToPositionOptions = {},
) {
  for (let i = 0; i < maxTries; i++) {
    const el = getScrollTargetFn();

    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    await new Promise((r) => setTimeout(r, delayMs));
  }
  console.warn('Target element not found after max retries');
}

export async function scrollToPosition({
  pageNumber,
  blockIndex,
}: ScrollTarget) {
  await waitAndScroll(() => getScrollTarget({ pageNumber, blockIndex }));
}
